<app-form-group
  [formGroupSize]="inputSize"
  [formGroupOrientation]="orientation"
  [formGroupLabelWidth]="effectiveLabelWidth"
  [formGroupInputWidth]="effectiveInputWidth"
  [formGroupControl]="control"
  [formGroupFormGroup]="formGroup"
  [formGroupValidationMessages]="validationMessages"
  [formGroupHintMessage]="hintMessage"
  [formGroupShouldShowHint]="shouldShowHint"
  [formGroupHasDistance]="hasDistance"
>
  <app-form-label
    class="form-group-label"
    [formLabelText]="label"
    [formLabelIsRequired]="isRequired"
    [formLabelIsOptional]="isOptional"
    [formLabelTooltipLabel]="tooltipLabel"
    [formLabelTooltipPosition]="tooltipPosition"
    [formLabelVerticalAlign]="verticalAlign"
    [formLabelIsDisabled]="isLabelDisabled"
    [formLabelOrientation]="orientation"
    [formLabelLabelWidth]="effectiveLabelWidth"
  >
    <div class="app-form-label-content">
      <ng-content select=".app-form-label-content"></ng-content>
    </div>
  </app-form-label>
  <ng-content class="form-group-input"></ng-content>
</app-form-group>
